import { Get } from '../requestBuilder/buildFetchRequest';
import PagedResponse from '../PagedResponse';
import Department from './Department';
import { QueryParameters, buildQueryParams } from '../QueryParameters';
import DepartmentQueryOptions from './DepartmentQueryOptions';

// eslint-disable-next-line import/prefer-default-export
export const getDepartments = (query: QueryParameters<Department, DepartmentQueryOptions>): Promise<PagedResponse<Department>> => (
  Get('/api/departments')
    .AddQueryParams(buildQueryParams(query))
    .Execute()
);
